/** Tvinga fönstret till toppen (Safari/Chrome kan använda documentElement eller body). */
export function forceScrollWindowToTop() {
  const scrollingEl = document.scrollingElement;
  try {
    window.scrollTo(0, 0);
  } catch {
    // ignore
  }

  if (scrollingEl) scrollingEl.scrollTop = 0;
  if (document.documentElement) document.documentElement.scrollTop = 0;
  if (document.body) document.body.scrollTop = 0;
}

export function smoothScrollWindowToTop() {
  const candidates = [
    document.scrollingElement,
    document.documentElement,
    document.body
  ].filter(Boolean);

  const getTop = () => {
    const wTop = typeof window !== 'undefined' ? (window.pageYOffset ?? window.scrollY ?? 0) : 0;
    const elTop = candidates.reduce((max, node) => {
      const t = typeof node.scrollTop === 'number' ? node.scrollTop : 0;
      return Math.max(max, t || 0);
    }, 0);
    return Math.max(wTop || 0, elTop || 0);
  };

  // Try smooth on window + all likely scroll containers.
  try {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  } catch {
    // ignore
  }
  for (const node of candidates) {
    try {
      if (typeof node.scrollTo === 'function') {
        node.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      } else if (typeof node.scrollTop === 'number') {
        node.scrollTop = 0;
      }
    } catch {
      // ignore
    }
  }

  // If after a short delay we're still not at the top, force it.
  window.setTimeout(() => {
    if (getTop() > 1) {
      forceScrollWindowToTop();
      requestAnimationFrame(() => forceScrollWindowToTop());
    }
  }, 220);
}

export function smoothScrollToElementId(id) {
  return scrollToElementId(id, 'smooth');
}

export function scrollToElementId(id, behavior = 'auto') {
  const el = document.getElementById(id);
  if (!el) return false;
  try {
    el.scrollIntoView({ behavior, block: 'start' });
  } catch {
    // Older browsers may not support options.
    el.scrollIntoView(true);
  }
  return true;
}

export function queueMicrotaskSafe(callback) {
  if (typeof callback !== 'function') return;
  if (typeof window !== 'undefined' && typeof window.queueMicrotask === 'function') {
    window.queueMicrotask(callback);
    return;
  }
  if (typeof queueMicrotask === 'function') {
    queueMicrotask(callback);
    return;
  }
  if (typeof Promise !== 'undefined') {
    Promise.resolve().then(callback);
    return;
  }
  setTimeout(callback, 0);
}
